// import React, { useState, useEffect, useMemo } from "react";
// import { Typography, Grid, Box, Button } from "@mui/material";
// import CustomTable from "components/TableExplanded/Table";
// import CustomPagination from "components/TableExplanded/Pagination";
// import useProductData from "pages/Pawn/Products/BuyItems/data/data";
// import useColumns from "pages/Pawn/Products/BuyItems/columns/mainColumns";
// import useColumnsTwo from "pages/Pawn/Products/BuyItems/columns/subColumns";
// import Modal from "components/Modal/Pawn/BuyProduct/ModalCreate";
// import ViewModal from "components/Modal/Pawn/View/ViewBuyItems";
// import SearchBar from "components/TableExplanded/SearchBar";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import {
//   GradientButton,
//   GradientButtonOutline,
// } from "components/GradientButton";
// import dayjs from "dayjs";
// import api from "_api";
// import SaveIcon from "@mui/icons-material/Save";

// const BuyItems = () => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [isModalOpen, setModalOpen] = useState(false);
//   const [isViewModalOpen, setViewModalOpen] = useState(false);
//   const [selectedProduct, setProduct] = useState(null);
//   const [viewProduct, setViewProduct] = useState(null);
//   const [filteredRows, setFilteredRows] = useState([]);
//   const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
//   const [fetchData, setFetchData] = useState();
//   const [searchQuery, setSearchQuery] = useState(""); // Store the search query
//   const [dataLength, setDataLength] = useState(0);

//   const fetchProductData = async () => {
//     try {
//       const { data, isStatus } = await api.product.getOrder();
//       // console.log("data", data);
//       if (isStatus) setFetchData(data);
//     } catch (error) {
//       console.error("Error fetching product data:", error);
//     }
//   };

//   useEffect(() => {
//     fetchProductData();
//   }, []);

//   const handleModalOpen = () => {
//     setModalOpen(!isModalOpen);
//     if (selectedProduct && isModalOpen) setProduct(null);
//   };

//   const handleViewOpen = () => {
//     setViewModalOpen(!isViewModalOpen);
//     if (viewProduct && isViewModalOpen) setViewProduct(null);
//   };

//   const data = useProductData(fetchData);
//   const columns = useColumns(
//     setViewProduct,
//     setProduct,
//     handleViewOpen,
//     handleModalOpen
//   );
//   const columnsInside = useColumnsTwo();
//   const visibleColumns = columns.filter((col) => col.showInFilter);

//   useEffect(() => {
//     setFilteredRows(data);
//   }, [data]);

//   const filteredData = useMemo(() => {
//     if (!searchQuery) return data; // If no search query, return all data

//     return data.filter((row) => {
//       return visibleColumns.some((column) => {
//         const cellValue = row[column.accessor]?.toString()?.toLowerCase();
//         return cellValue && cellValue.includes(searchQuery.toLowerCase());
//       });
//     });
//   }, [data, searchQuery, visibleColumns]);

//   const handleSearchChange = (event) => {
//     // Check if event.target and event.target.value are defined
//     if (
//       event &&
//       event.target &&
//       event.target.value !== undefined &&
//       event.target.value !== null
//     ) {
//       setSearchTerm(event.target.value.toLowerCase());
//       setSearchQuery(event.target.value);
//     } else {
//       console.error("Event target or value is undefined");
//     }
//     setPage(0);
//   };

//   const handleDateRangeChange = (dates) => {
//     setSelectedDateRange(dates);
//   };

//   const handlePageChange = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleRowsPerPageChange = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleClear = () => {
//     setSearchTerm("");
//     setSelectedDateRange([null, null]);
//     setFilteredRows(data);
//     setPage(0);
//   };

//   const handleExportExcel = async () => {
//     console.log("Export Excel");
//     await api.product
//       .exportExcelBuyProduct()
//       .then((res) => {
//         const contentDisposition = res.headers["content-disposition"];
//         let filename = "download.xlsx"; // Default กรณีไม่มีชื่อไฟล์จาก API

//         if (contentDisposition) {
//           const match = contentDisposition.match(/filename="?(.+?)"?$/);
//           if (match && match[1]) {
//             filename = match[1];
//           }
//         }

//         const url = window.URL.createObjectURL(new Blob([res.data]));
//         const link = document.createElement("a");
//         link.href = url;
//         link.setAttribute("download", filename);
//         document.body.appendChild(link);
//         link.click();
//       })
//       .catch((error) => {
//         console.error("Error exporting excel:", error);
//       });
//   };

//   return (
//     <div>
//       <Grid container spacing={2} style={{ marginBottom: "16px" }}>
//         <Grid
//           item
//           xs={12}
//           sm={12}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <Typography component="div" style={{ fontSize: "32px" }}>
//             สินค้าที่ซื้อ
//           </Typography>
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "row",
//               alignItems: "center",
//               gap: 1,
//             }}
//           >
//             <GradientButtonOutline
//               onClick={handleExportExcel}
//               sx={{
//                 px: 3,
//                 display: "flex",
//                 alignItems: "center",
//                 height: "48px",
//               }}
//             >
//               <Typography style={{ marginRight: "8px" }}>
//                 ส่งออก Excel
//               </Typography>
//               <SaveIcon fontSize="medium" />
//             </GradientButtonOutline>
//             <GradientButton
//               onClick={handleModalOpen}
//               sx={{
//                 px: 3,
//                 display: "flex",
//                 alignItems: "center",
//                 height: "48px",
//               }}
//             >
//               <Typography style={{ marginRight: "8px" }}>ซื้อสินค้า</Typography>
//               <AddCircleIcon fontSize="medium" />
//             </GradientButton>
//           </Box>
//         </Grid>
//       </Grid>

//       <SearchBar
//         columns={columns}
//         searchTerm={setSearchTerm}
//         visibleColumns={visibleColumns} // กรองคอลัมน์ที่ต้องการแสดง
//         handleSearchChange={handleSearchChange}
//         // handleSearchClick={handleSearchClick}
//         handleClear={handleClear}
//         handleDateRangeChange={handleDateRangeChange}
//         fetchData={fetchData}
//         QRCode={false}
//       />

//       <CustomTable
//         columns={columns}
//         columnsInside={columnsInside}
//         searchTerm={searchTerm}
//         data={filteredData}
//         setDataLength={setDataLength}
//         page={page}
//         rowsPerPage={rowsPerPage}
//       />

//       <CustomPagination
//         count={searchTerm ? dataLength : filteredData.length}
//         page={page}
//         rowsPerPage={rowsPerPage}
//         onPageChange={handlePageChange}
//         onRowsPerPageChange={handleRowsPerPageChange}
//       />

//       <Modal
//         open={isModalOpen}
//         onClose={handleModalOpen}
//         selectedProduct={selectedProduct}
//         fetchProductData={fetchProductData}
//         disableBackdropClick // Prevent clicking outside
//         disableEscapeKeyDown // Prevent pressing `Esc`
//       />

//       <ViewModal
//         open={isViewModalOpen}
//         onClose={handleViewOpen}
//         selectedProduct={viewProduct}
//         fetchProductData={fetchProductData}
//         disableBackdropClick // Prevent clicking outside
//         disableEscapeKeyDown // Prevent pressing `Esc`
//       />
//     </div>
//   );
// };

// export default BuyItems;

import React, { useState, useEffect, useMemo } from "react";
import { Typography, Grid, Box, Button } from "@mui/material";
import CustomTable from "components/TableExplanded/Table";
import CustomPagination from "components/TableExplanded/Pagination";
import useProductData from "pages/Pawn/Products/BuyItems/data/data";
import useColumns from "pages/Pawn/Products/BuyItems/columns/mainColumns";
import useColumnsTwo from "pages/Pawn/Products/BuyItems/columns/subColumns";
import Modal from "components/Modal/Pawn/BuyProduct/ModalCreate";
import ViewModal from "components/Modal/Pawn/View/ViewBuyItems";
import SearchBar from "components/TableExplanded/SearchBar";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import dayjs from "dayjs";
import api from "_api";
import SaveIcon from "@mui/icons-material/Save";
import ModalBuyForm from "components/Modal/Pawn/Print/ModalBuyForm";

const BuyItems = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [isModalPrint, setIsModalPrint] = useState(false);
  const [selectedProduct, setProduct] = useState(null);
  const [viewProduct, setViewProduct] = useState(null);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
  const [fetchData, setFetchData] = useState();
  const [searchQuery, setSearchQuery] = useState(""); // Store the search query
  const [dataLength, setDataLength] = useState(0);

  const fetchProductData = async ({ search = "", page = 1, limit = 10 }) => {
    try {
      const { data, isStatus, total } = await api.product.getOrderV2({
        search,
        page,
        limit,
      });
      if (isStatus) {
        setFetchData(data);
        setDataLength(total); // Set the total data length for pagination
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  useEffect(() => {
    fetchProductData({
      search: searchQuery,
      page: page + 1,
      limit: rowsPerPage,
    });
  }, [searchQuery, page, rowsPerPage]);

  const handleModalOpen = () => {
    setModalOpen(!isModalOpen);
    if (selectedProduct && isModalOpen) setProduct(null);
  };

  const handleViewOpen = () => {
    setViewModalOpen(!isViewModalOpen);
    if (viewProduct && isViewModalOpen) setViewProduct(null);
  };

  const handleModalPrint = () => {
    setIsModalPrint(!isModalPrint);
  };

  const data = useProductData(fetchData);
  const columns = useColumns(
    setViewProduct,
    setProduct,
    handleViewOpen,
    handleModalOpen,
    handleModalPrint
  );
  const columnsInside = useColumnsTwo();
  const visibleColumns = columns.filter((col) => col.showInFilter);

  useEffect(() => {
    setFilteredRows(data);
  }, [data]);

  // const filteredData = useMemo(() => {
  //   if (!searchQuery) return data; // If no search query, return all data

  //   return data.filter((row) => {
  //     return visibleColumns.some((column) => {
  //       const cellValue = row[column.accessor]?.toString()?.toLowerCase();
  //       return cellValue && cellValue.includes(searchQuery.toLowerCase());
  //     });
  //   });
  // }, [data, searchQuery, visibleColumns]);

  const handleSearchChange = (event) => {
    if (
      event &&
      event.target &&
      event.target.value !== undefined &&
      event.target.value !== null
    ) {
      const query = event.target.value.toLowerCase();
      setSearchTerm(query);
      setSearchQuery(query);
    } else {
      console.error("Event target or value is undefined");
    }
    setPage(0);
  };

  const handleDateRangeChange = (dates) => {
    setSelectedDateRange(dates);
  };

  const handlePageChange = (event, newPage) => {
    if (searchTerm != null) {
      setSearchQuery(searchTerm.order_code);
    }
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClear = () => {
    setSearchTerm("");
    setSelectedDateRange([null, null]);
    setFilteredRows(data);
    setPage(0);
    fetchProductData({ search: "", page: 1, limit: rowsPerPage });
  };

  const handleExportExcel = async () => {
    console.log("Export Excel");
    await api.product
      .exportExcelBuyProduct()
      .then((res) => {
        const contentDisposition = res.headers["content-disposition"];
        let filename = "download.xlsx"; // Default กรณีไม่มีชื่อไฟล์จาก API

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+?)"?$/);
          if (match && match[1]) {
            filename = match[1];
          }
        }

        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error("Error exporting excel:", error);
      });
  };

  return (
    <div>
      <Grid container spacing={2} style={{ marginBottom: "16px" }}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography component="div" style={{ fontSize: "32px" }}>
            สินค้าที่ซื้อ
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
            }}
          >
            <GradientButtonOutline
              onClick={handleExportExcel}
              sx={{
                px: 3,
                display: "flex",
                alignItems: "center",
                height: "48px",
              }}
            >
              <Typography style={{ marginRight: "8px" }}>
                ส่งออก Excel
              </Typography>
              <SaveIcon fontSize="medium" />
            </GradientButtonOutline>
            <GradientButton
              onClick={handleModalOpen}
              sx={{
                px: 3,
                display: "flex",
                alignItems: "center",
                height: "48px",
              }}
            >
              <Typography style={{ marginRight: "8px" }}>ซื้อสินค้า</Typography>
              <AddCircleIcon fontSize="medium" />
            </GradientButton>
          </Box>
        </Grid>
      </Grid>

      <SearchBar
        columns={columns}
        searchTerm={setSearchTerm}
        visibleColumns={visibleColumns} // กรองคอลัมน์ที่ต้องการแสดง
        handleSearchChange={handleSearchChange}
        // handleSearchClick={handleSearchClick}
        handleClear={handleClear}
        handleDateRangeChange={handleDateRangeChange}
        fetchData={fetchData}
        handleSearchClick={(filters) => {
          fetchProductData({
            search: filters.search || "",
            page: 1,
            limit: rowsPerPage,
          });
        }}
        QRCode={false}
      />

      <CustomTable
        columns={columns}
        columnsInside={columnsInside}
        searchTerm={searchTerm}
        data={data}
        setDataLength={setDataLength}
        page={page}
        rowsPerPage={rowsPerPage}
      />

      <CustomPagination
        count={dataLength}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <Modal
        open={isModalOpen}
        onClose={handleModalOpen}
        selectedProduct={selectedProduct}
        // fetchProductData={fetchProductData}
        fetchProductData={() =>
          fetchProductData({
            search: searchQuery,
            page: page + 1,
            limit: rowsPerPage,
          })
        }
        disableBackdropClick // Prevent clicking outside
        disableEscapeKeyDown // Prevent pressing `Esc`
      />

      <ModalBuyForm
        open={isModalPrint}
        onClose={handleModalPrint}
        selectedProduct={selectedProduct}
      />

      <ViewModal
        open={isViewModalOpen}
        onClose={handleViewOpen}
        selectedProduct={viewProduct}
        fetchProductData={() =>
          fetchProductData({
            search: searchQuery,
            page: page + 1,
            limit: rowsPerPage,
          })
        }
        disableBackdropClick // Prevent clicking outside
        disableEscapeKeyDown // Prevent pressing `Esc`
      />
    </div>
  );
};

export default BuyItems;
